import { ContributionKpiConfig } from '../../../elements/kpiDecomposition/types';
import { ContentInstructions, CoreContents } from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type KpiDecompositionOptions = {
  data?: DataOptionsFactory;
  periodName: string;
  decomposedKpi: string;
  contributingKpis: ContributionKpiConfig[];
};

export class KpiDecompositionFactory extends ContentFactory {
  constructor(options: KpiDecompositionOptions) {
    const { data, decomposedKpi, contributingKpis, periodName } = options;

    const instructions: ContentInstructions = {
      periodName:
        typeof periodName === 'string'
          ? {
              type: 'StringInstruction',
              instruction: periodName,
            }
          : periodName,
      decomposedKpi:
        typeof decomposedKpi === 'string'
          ? {
              type: 'StringInstruction',
              instruction: decomposedKpi,
            }
          : decomposedKpi,
      contributingKpis: {
        type: 'ObjectInstruction',
        instruction: contributingKpis,
      },
    };

    super(CoreContents.kpiDecompositon, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
